var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.domains,"bordered":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }